import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './translations/en';
import frTranslation from './translations/fr';
import esTranslation from './translations/es';
import ptTranslation from './translations/pt';
import { adminTranslations } from './translations/admin';

// Merge admin translations with main translations
const resources = {
  en: {
    translation: {
      ...enTranslation,
      admin: adminTranslations.en
    }
  },
  fr: {
    translation: {
      ...frTranslation,
      admin: adminTranslations.fr
    }
  },
  es: {
    translation: {
      ...esTranslation,
      admin: adminTranslations.es
    }
  },
  pt: {
    translation: {
      ...ptTranslation,
      admin: adminTranslations.pt
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;